import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-documents-stack-loader',
    imports: [CommonModule],
    standalone: true,
    templateUrl: './documents-stack-loader.component.html',
    styleUrls: ['./documents-stack-loader.component.scss']
})
export class DocumentsStackLoaderComponent {
    @Input() text: string = 'In Queue';
    @Input() width: 'half' | 'full' = 'half';
    @Input() size: 'compact' | 'large' = 'compact';
    @Input() showText: boolean = true;
    @Input() queuePosition: number = 1;
    @Input() totalInQueue: number = 5;
    @Input() showQueueInfo: boolean = false;

    get containerClasses(): string {
        return `${this.width}-width ${this.size}`;
    }
}
